import React, { Component } from "react";
import _ from "lodash";
import glamorous from "glamorous";
import Link from "redux-first-router-link";
import { connect } from "react-redux";

import logo from "../../assets/fv_logo_2.png";
import logoSm from "../../assets/fv_logo.png";
import { Logo } from "../../components/logos";
import ArrowBack from "react-icons/lib/md/arrow-back";

import { routesList } from "../../routes";

function NavToggle(props) {
  const { sidebarMinimize, toggle } = props;

  return (
    <glamorous.Div
      css={{
        alignItems: "center",
        cursor: "pointer",
        display: "flex",
        flex: "auto",
        flexDirection: "row",
        justifyContent: "flex-end",
        marginLeft: 10,
        marginRight: 12,
        position: "absolute",
        right: 4,
        top: 3,
        width: 35,
        height: 35
      }}
      onClick={() => toggle(!sidebarMinimize)}
    >
      <span>
        <ArrowBack style={{ color: "#fbd20e", fontSize: 18 }} />
        <glamorous.Span
          css={{
            backgroundColor: "#57606d",
            height: 18,
            width: 6
          }}
        />
      </span>
    </glamorous.Div>
  );
}

function NavItem({ active, sidebarMinimize, icon, screen }) {
  const NavItem = glamorous.div({
    alignItems: "center",
    backgroundColor: active ? "#68b4fc" : "#33444c",
    color: active ? "#23344a" : "#acb5be",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
    fontSize: "medium",
    height: "2.375em",
    marginBottom: ".75em",
    paddingLeft: ".75em",
    position: "relative",
    ":hover > .nav-rollover": { visibility: "visible" }
  });

  const iconStyles = {
    color: active ? "white" : "#515f6b",
    marginRight: ".5em"
  };

  let rolloverElem = sidebarMinimize ? (
    <glamorous.Span
      className="nav-rollover"
      css={{
        backgroundColor: "#33444c",
        borderRadius: 16,
        boxShadow: "4px 4px rgba(0, 0, 0, 0.4)",
        color: "white",
        fontSize: "small",
        fontWeight: 300,
        left: "75%",
        padding: "5px 0",
        position: "absolute",
        textAlign: "center",
        top: 6,
        visibility: "hidden",
        width: 230,
        zIndex: 20001,
        "&::after": {
          borderWidth: 5,
          borderStyle: "solid",
          borderColor: "transparent #67b5ff transparent transparent",
          content: `""`,
          marginTop: "-5px",
          position: "absolute",
          right: "100%",
          top: "50%"
        }
      }}
    >
      {screen.title}
    </glamorous.Span>
  ) : null;

  return (
    <NavItem active={active}>
      <span style={iconStyles}>{icon}</span>
      {!sidebarMinimize ? <span>{screen.title}</span> : null}
      {rolloverElem}
    </NavItem>
  );
}

function NavLink({
  actionType,
  icon,
  currentLocation,
  title,
  sidebarMinimize
}) {
  /* active nav hightlight doesn't account for hidden nav views 
      which makes it look like it stops working, so disabled for now */
  // let isActive = currentLocation === actionType;
  let isActive = false;
  return (
    <Link to={{ type: actionType }}>
      <NavItem
        screen={{ title }}
        active={isActive}
        icon={icon}
        sidebarMinimize={sidebarMinimize}
      />
    </Link>
  );
}

class AppNavView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollX: 0
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll.bind(this));
  }
  handleScroll(event) {
    if (this.refs.footer_nav && window.scrollX !== this.state.scrollX) {
      this.setState({ scrollX: window.scrollX });
    }
  }

  render() {
    const {
      currentLocation,
      sidebarMinimize,
      toggle,
      organizations
    } = this.props;
    const currentOrganizationId = sessionStorage.getItem("currentOrganization");
    const organization = _.find(organizations, {
      organization_id: Number(currentOrganizationId)
    });
    const isShipper = organization
      ? organization.org_type === "Shipper" ||
        organization.org_type === "FreightVerify"
      : false;

    let navElem = routesList
      .filter(r => r.screen.showInSidebar)
      .map((route, i) => {
        const { screen } = route;

        return !isShipper &&
          (route.path === "/locations" ||
            route.path === "/locationmanagement") ? null : (
          <NavLink
            key={i}
            title={screen.title}
            location={route.path}
            icon={screen.icon}
            actionType={screen.id}
            sidebarMinimize={sidebarMinimize}
            currentLocation={currentLocation}
          />
        );
      });

    return (
      <glamorous.Aside
        css={{
          color: "#acb5be",
          flexDirection: "column",
          flex: 1,
          zIndex: 300
        }}
      >
        <glamorous.Div
          style={{
            backgroundColor: "#2c3948",
            cursor: sidebarMinimize ? "pointer" : "auto",
            position: "relative",
            paddingLeft: "1.25em"
          }}
          onClick={
            sidebarMinimize ? () => toggle(!sidebarMinimize) : () => null
          }
        >
          <Logo
            style={{ height: "2em", margin: ".5em" }}
            src={sidebarMinimize ? logoSm : logo}
          />
          {!sidebarMinimize ? (
            <NavToggle sidebarMinimize={sidebarMinimize} toggle={toggle} />
          ) : null}
        </glamorous.Div>
        <glamorous.Div
          css={{
            marginTop: "2.5em",
            paddingLeft: "1.25em"
          }}
        >
          {navElem}
        </glamorous.Div>
      </glamorous.Aside>
    );
  }
}

function mapStateToProps(state) {
  return {
    organizations: state.organizations.data
      ? state.organizations.data.response
      : state.organizations.data
  };
}

export default connect(mapStateToProps)(AppNavView);



// WEBPACK FOOTER //
// ./src/modules/appnav/AppNavView.js